import gql from 'graphql-tag'

export const PROCESS_USER_STATUS_FILE = gql`
  mutation processUserStatusFile($input: ProcessUserStatusFileInput!) {
    userStatusFile(input: $input) {
      success
      error
    }
  }
`
